import { UserData } from "../../types/responseTypes";

async function validateCookie(): Promise<[UserData | null, number]> {
  try {
    const url = `https://ruuf-backend.online/user`;
    const timeout = new Promise<number>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    const userData: UserData = await response.json();

    if (response.status === 200) {
      console.log("Cookie is valid");
      return [userData, 0]; // Cookie is valid
    } else if (response.status === 502) {
      console.error("Invalid cookie: Error fetching user data");
      return [null, 1]; // Invalid cookie
    } else {
      throw new Error("Could not validate cookie");
    }
  } catch (error) {
    console.error("Error validating cookie:", error);
    return [null, -1]; // Error validating cookie
  }
}

export default validateCookie;